"use client";

import { ArrowLeft, Home } from "lucide-react";
import { useTranslations } from "next-intl";

import { Link } from "@/i18n/navigation";
import { Button } from "@/shared/ui/buttons/button";
import FuzzyText from "@/shared/ui/FuzzyText";

export default function NotFound() {
  const t = useTranslations("System.NotFound");
  return (
    <div className="flex h-[80vh] flex-col items-center justify-center gap-8 p-4 text-center">
      <div className="space-y-4">
        <FuzzyText>{t("code")}</FuzzyText>
        <h2 className="text-2xl font-semibold tracking-tight">{t("title")}</h2>
        <p className="text-muted-foreground">{t("description")}</p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button asChild variant="outline" size="lg">
          <Link href="/">
            <Home className="mr-2 h-4 w-4" />
            {t("goHome")}
          </Link>
        </Button>
        <Button variant="ghost" size="lg" onClick={() => window.history.back()}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t("goBack")}
        </Button>
      </div>
    </div>
  );
}
